import { render } from "./GestionarReservas.vue?vue&type=template&id=d69c136c"
import script from "./GestionarReservas.vue?vue&type=script&lang=js"
export * from "./GestionarReservas.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/tesoreria_tolima/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__